export default "__VITE_PUBLIC_ASSET__f990365a__"